<template>
  <main>
    <wl-banner bgUrl='/static/img/product/sjhc/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc' class="mytitle"></wl-title>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/bg-cptx-677.png'">
      <article class="container">
        <wl-title title='产品特性' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="box" v-for="(item,index) in page2Data" :key="item.key" @mouseenter="mouseEnter(index)" @mouseleave="page2HoverId = null">
            <section class="_icon " :style="page2HoverId===index?`background-position: -${72+144*index}px 0px;`:`background-position: -${144*index}px 0px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/sjhc/bg3.png'">
      <article class="container">
<!--        <wl-title title='灵活搭载智能硬件,实现智能化管理' :isNeedDesc=false></wl-title>-->
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'sjhcManageSystem',
  data() {
    return {
      bannerData: {
        title: '试剂耗材管理系统',
        desc: '试剂耗材全流程管理\n库存可查 来源可循 去向可追 消息预警'
      },
      page1Data: {
        title: '试剂耗材管理系统',
        desc: '试剂耗材管理系统 将实验室玻璃器皿、试剂耗材、办公用品等物资进行统一管理，从申购采购、入库、领用、出库、盘点、库存流水等环节进行全程监管，合理采购、储存和使用；精准库存，规避浪费，节约成本，优化流程， 提高工作效率。'
      },
      page2Data: [
        { key: 'sjhc-icon1', title: '申购采购', desc: '在线申购审批\n自动汇总采购需求\n生成验收记录' },
        { key: 'sjhc-icon2', title: '库存管理', desc: '库存预警\n实时盘点\n出入库管理' },
        { key: 'sjhc-icon3', title: '领用管理', desc: '领用申请\n领用出库\n归还处理' },
        { key: 'sjhc-icon4', title: '统计分析', desc: '入库统计\n出库统计\n库存统计、采购统计' },
      ],
      page2HoverId: null,
    }
  },
  methods: {
    mouseEnter(index) {
      this.page2HoverId = index
    },
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/sjhc/icon.png");
  display: inline-block;
}
main {
  background: #fbfbff;
}
h3 {
  font-size: 22px;
  font-weight: 500;
  color: #262626;
  line-height: 22px;
  padding-bottom: 12px;
  padding-top: 16px;
}
p {
  font-size: 20px;
  color: #8e8e8e;
  line-height: 30px;
  white-space: pre-line;
}
.pt-30 {
  padding-top: 32px !important;
}
.page1 {
  height: 579px;
  padding-top: 164px;
  background: url("/static/img/product/sjhc/bg1.png") center/cover;
  text-align: left;
  .mytitle {
    width: 600px;
    margin-left: 670px;
    ::v-deep strong {
      color: #8e8e8e;
      line-height: 38px;
      padding-top: 23px;
    }
  }
}
.page2 {
  height: 677px;
  padding-top: 136px;
  .flexWrap {
    padding-top: 65px;
  }
  .box {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 14px;
    padding: 0 24px;
    padding-top: 42px;
    ._icon {
      width: 72px;
      height: 72px;
    }
    &:hover {
      background: linear-gradient( 360deg, #FF9222 0%, #F56728 100%);
      h3 {
        color: #fff;
      }
      p {
        color: #fff;
      }
    }
  }
}
.page3 {
  padding-top: 136px;
  height: 819px;
}
</style>
